<ng-container *ngIf="(loadingPaymentMethods$$ | async) === false; else loadingPaymentMethods">
  <smb-invoicing-payment-method-selector
    [isEditable]="isEditable"
    [stripeKey]="stripeKey"
    [defaultPaymentMethod]="defaultPaymentMethod$$ | async"
    [customerId]="customerId"
    [addCardButton]="'PAYMENT_METHOD_SELECTOR.ADD_PAYMENT_METHOD' | translate"
    [emptyCardHintText]="emptyCardHintText"
    [editButton]="'PAYMENT_METHOD_SELECTOR.EDIT' | translate"
    [makeDefaultButton]="'PAYMENT_METHOD_SELECTOR.USE_AS_DEFAULT' | translate"
    [hintText]="hintText"
    [submitDialogText]="submitDialogText"
    [merchantId]="merchantId"
    [stripeConnectId]="stripeConnectId"
    [paymentMethods]="paymentMethods$$ | async"
    [canRemoveSelectedMethod]="canRemoveSelectedMethod"
    (selectedPaymentMethod)="selectPaymentMethod($event)"
    [showAllMethods]="showAllMethods"
  ></smb-invoicing-payment-method-selector>
</ng-container>
<ng-template #loadingPaymentMethods>
  <div matLine>
    <div class="stencil-shimmer"></div>
  </div>
</ng-template>
